import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import ChevronSvg from '../../../assets/icons/chevron.svg?react';
import { css } from '@emotion/react';
import { RebrandTheme } from '../../common/models/common.models';
import { TSkeleton } from '@toluna/design-system';

export const FooterWrapper = styled.div<{ breakLine?: boolean; disabled?: boolean }>`
    height: 56px;
    width: 100%;
    background: #fff 0% 0% no-repeat padding-box;
    opacity: 1;
    border-top: 1px solid #cfd9db;
    white-space: ${props => (props.breakLine ? 'pre-line' : undefined)};
    ${({ disabled }) =>
        disabled &&
        css`
            pointer-events: none;
        `};
`;

export const FooterContent = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`;

export const FooterLeft = styled.div<{ theme?: any }>`
    display: flex;
    align-items: center;
    flex: 1;
    gap: 36px;
    padding: 0 20px;
    > a,
    span {
        &:hover {
            color: ${props => props.theme.footer?.footerLeft.colorHover};
        }
    }
    @media (max-width: 1440px) {
        gap: 24px;
    }
`;

export const FooterRights = styled.div<{ theme?: any }>`
    font-family: ${props => props.theme.footer?.rights.fontFamily};
    font-size: 12px;
    color: #707070;
    opacity: 0.6;
    letter-spacing: 0;
    font-weight: 300;
`;

export const FooterItem = styled.a<{ theme?: any }>`
    font-size: 12px;
    font-weight: 400;
    color: #60738f;
    opacity: 1;
    letter-spacing: 0;
    font-family: ${props => props.theme.footer?.link.fontFamily};
    text-decoration: none;

    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        border-radius: 2px;
    }
`;

export const LinkedFooterItem = styled(Link)<{ theme?: any }>`
    font-size: 12px;
    font-weight: 400;
    color: #60738f;
    opacity: 1;
    letter-spacing: 0;
    font-family: ${props => props.theme.footer?.link.fontFamily};
    text-decoration: none;

    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        border-radius: 2px;
    }
`;

export const ContactUs = styled.span<{ theme?: any }>`
    font-size: 12px;
    font-weight: 400;
    color: #60738f;
    opacity: 1;
    letter-spacing: 0;
    font-family: ${props => props.theme.footer?.link.fontFamily};
    text-decoration: none;
    cursor: pointer;

    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        border-radius: 2px;
    }
`;

export const LanguageSelectorWrapper = styled.div<{ theme?: RebrandTheme }>`
    display: flex;
    position: relative;
    flex-direction: column;
    margin-right: 12px;
    background-color: #f1f1f1;
    border-radius: 100px;

    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
    }
`;

export const LanguageSelectorMenuButton = styled.div<{ theme?: any }>`
    height: 28px;
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;
    color: #7a7a7a;
    padding: 7px 16px;
    font-family: ${props => props.theme.footer?.rights.fontFamily};
`;

export const LanguageSelectorButtonText = styled.div`
    font-size: 12px;
    font-weight: 600;
`;

export const LanguageSelectorOptionsWrapper = styled.div`
    background: #fff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 21px #00000027;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    margin-bottom: 4px;
    color: #60738f;
    padding: 5px;
`;

export const LanguageSelectorOption = styled.div<{ theme?: RebrandTheme }>`
    font-size: 14px;
    text-align: left;
    padding: 16px 24px;
    cursor: pointer;
    font-family: ${props => props.theme.footer?.rights.fontFamily};
    &:hover {
        background: #f0f0f0;
    }
    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        border-radius: 2px;
    }
`;

export const LanguageSelectorArrowWrapper = styled.div`
    // padding-right: 16px;
    > i {
        padding-top: 4px;
    }
`;

export const ChevronIcon = styled(ChevronSvg)<{ rotated: boolean }>`
    transition: all 0.3s ease-in-out;
    ${({ rotated }) =>
        rotated &&
        css`
            transform: rotate(180deg);
        `}
`;

export const StyledSkeleton = styled(TSkeleton)<{ theme?: RebrandTheme }>`
    &.MuiSkeleton-root {
        background-color: ${({ theme }) => theme.skeletonColor} !important;
    }
`;

export const StyledLanguageSelectorSkeleton = styled(StyledSkeleton)`
    &.MuiSkeleton-root {
        border-radius: 100px;
    }
`;
